<ng-container *ngIf="!isDismissed && passwordExpiry">
  <ng-leaf-alert
    [headerText]="headerText"
    variant="banner"
    status="error"
    [notDismissible]="false"
    class="alert-block"
    (leaf-alert-dismissed)="handleDismiss($event)"
  >
    <ng-container *ngIf="passwordExpiry < 0; else countdownWarn">
      <div>
        <a
          data-test-id="link-lockout"
          [routerLink]="['/preferences/security/password']"
          >Please change it now</a
        >
        to avoid being locked out of the website.
      </div>
    </ng-container>
    <ng-template #countdownWarn>
      <div class="">
        <a
          data-test-id="link-expiring"
          [routerLink]="['/preferences/security/password']"
          >Please change it now</a
        >
        to avoid being locked out of the website on {{ lockoutDate }}
      </div>
    </ng-template>
  </ng-leaf-alert>
</ng-container>
